import { FormLabel, type SxProps, type Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

import { type FieldSize } from "ui/forms/field-size";

export const FieldLabelRoot = styled(FormLabel)({
  display: "block",
});

/**
 * The label's own type step, plus a `minHeight` holding the row open so that a `Select` and a
 * `TextField` sitting side by side start their controls on the same line. `sx` rather than
 * `styled()` because it has to out-rank `MuiFormLabel`'s line-height.
 *
 * The variant is read a property at a time on purpose — spreading `theme.typography.body1` would
 * land its `fontWeight: 400` after the theme's `700` and un-bold every label in the app.
 */
export const FIELD_LABEL_SIZE_SX: Record<FieldSize, SxProps<Theme>> = {
  medium: (theme) => ({
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    minHeight: theme.typography.body1.lineHeight,
  }),
  small: (theme) => ({
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    minHeight: theme.typography.body2.lineHeight,
  }),
};

export const FIELD_LABEL_ROW_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
};

export const FIELD_LABEL_GENERATION_ICON_SX: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  verticalAlign: "middle",
  color: theme.palette.grey[600],
  "&:hover": {
    color: theme.palette.grey[900],
  },
});
